import { render, staticRenderFns } from "./EditarVacunacion.vue?vue&type=template&id=137da056&scoped=true"
import script from "./EditarVacunacion.vue?vue&type=script&lang=js"
export * from "./EditarVacunacion.vue?vue&type=script&lang=js"
import style0 from "./EditarVacunacion.vue?vue&type=style&index=0&id=137da056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137da056",
  null
  
)

export default component.exports